import {
  dateToCurrentPlainDate,
  plainDateToCurrentDate,
} from "@redotech/util/temporal";
import { RedoSingleDatePicker } from "../../../arbiter-components/date-picker/redo-single-date-picker";
import {
  RedoTimePicker,
  TimeOfDay,
} from "../../../arbiter-components/time/redo-time-picker";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import { INITIAL_START_TIME } from "../../discount-shared";

export function StartDateTimeField({
  startDate,
  setStartDate,
  startTime,
  setStartTime,
}: {
  startDate: Date | undefined;
  setStartDate: (date: Date | undefined) => void;
  startTime: TimeOfDay | null;
  setStartTime: (time: TimeOfDay | null) => void;
}) {
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Start date & time (optional)
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex align="center" gap="sm">
        <RedoSingleDatePicker
          buttonSize="sm"
          date={startDate ? dateToCurrentPlainDate(startDate) : undefined}
          setDate={(date) => {
            const newDate = date ? plainDateToCurrentDate(date) : undefined;
            setStartDate(newDate);
            if (!newDate && startTime) {
              setStartTime(INITIAL_START_TIME);
            }
          }}
        />
        <RedoTimePicker
          disabled={!startDate}
          setValue={setStartTime}
          size="sm"
          value={startTime}
        />
      </Flex>
    </LabeledInput>
  );
}
